"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPromiseQueue;

var _pDeferEs = _interopRequireDefault(require("p-defer-es5"));

function createPromiseQueue() {
  var deferred;
  var queue = [];

  var push = function push(value) {
    if (deferred) {
      var _deferred = deferred,
          resolve = _deferred.resolve;
      deferred = null;
      resolve(value);
    } else {
      queue.push(value);
    }
  };

  var shift = function shift() {
    return queue.length ? Promise.resolve(queue.shift()) : (deferred || (deferred = (0, _pDeferEs["default"])())).promise;
  };

  return {
    push: push,
    shift: shift
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVQcm9taXNlUXVldWUiLCJkZWZlcnJlZCIsInF1ZXVlIiwicHVzaCIsInZhbHVlIiwicmVzb2x2ZSIsInNoaWZ0IiwibGVuZ3RoIiwiUHJvbWlzZSIsImNyZWF0ZURlZmVycmVkIiwicHJvbWlzZSJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uL3NyYy9jcmVhdGVQcm9taXNlUXVldWUuanMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IGNyZWF0ZURlZmVycmVkIGZyb20gJ3AtZGVmZXItZXM1JztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlUHJvbWlzZVF1ZXVlKCkge1xuICBsZXQgZGVmZXJyZWQ7XG4gIGNvbnN0IHF1ZXVlID0gW107XG5cbiAgY29uc3QgcHVzaCA9IHZhbHVlID0+IHtcbiAgICBpZiAoZGVmZXJyZWQpIHtcbiAgICAgIGNvbnN0IHsgcmVzb2x2ZSB9ID0gZGVmZXJyZWQ7XG5cbiAgICAgIGRlZmVycmVkID0gbnVsbDtcbiAgICAgIHJlc29sdmUodmFsdWUpO1xuICAgIH0gZWxzZSB7XG4gICAgICBxdWV1ZS5wdXNoKHZhbHVlKTtcbiAgICB9XG4gIH07XG5cbiAgY29uc3Qgc2hpZnQgPSAoKSA9PlxuICAgIHF1ZXVlLmxlbmd0aCA/IFByb21pc2UucmVzb2x2ZShxdWV1ZS5zaGlmdCgpKSA6IChkZWZlcnJlZCB8fCAoZGVmZXJyZWQgPSBjcmVhdGVEZWZlcnJlZCgpKSkucHJvbWlzZTtcblxuICByZXR1cm4ge1xuICAgIHB1c2gsXG4gICAgc2hpZnRcbiAgfTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRWUsU0FBU0Esa0JBQVQsR0FBOEI7RUFDM0MsSUFBSUMsUUFBSjtFQUNBLElBQU1DLEtBQUssR0FBRyxFQUFkOztFQUVBLElBQU1DLElBQUksR0FBRyxTQUFQQSxJQUFPLENBQUFDLEtBQUssRUFBSTtJQUNwQixJQUFJSCxRQUFKLEVBQWM7TUFDWixnQkFBb0JBLFFBQXBCO01BQUEsSUFBUUksT0FBUixhQUFRQSxPQUFSO01BRUFKLFFBQVEsR0FBRyxJQUFYO01BQ0FJLE9BQU8sQ0FBQ0QsS0FBRCxDQUFQO0lBQ0QsQ0FMRCxNQUtPO01BQ0xGLEtBQUssQ0FBQ0MsSUFBTixDQUFXQyxLQUFYO0lBQ0Q7RUFDRixDQVREOztFQVdBLElBQU1FLEtBQUssR0FBRyxTQUFSQSxLQUFRO0lBQUEsT0FDWkosS0FBSyxDQUFDSyxNQUFOLEdBQWVDLE9BQU8sQ0FBQ0gsT0FBUixDQUFnQkgsS0FBSyxDQUFDSSxLQUFOLEVBQWhCLENBQWYsR0FBZ0QsQ0FBQ0wsUUFBUSxLQUFLQSxRQUFRLEdBQUcsSUFBQVEsb0JBQUEsR0FBaEIsQ0FBVCxFQUE0Q0MsT0FEaEY7RUFBQSxDQUFkOztFQUdBLE9BQU87SUFDTFAsSUFBSSxFQUFKQSxJQURLO0lBRUxHLEtBQUssRUFBTEE7RUFGSyxDQUFQO0FBSUQifQ==